import { createContext, useEffect, useState } from "react";
import api from "../constants/api";
import { isTokenExpired } from "../constants/isTokenExpired.js";

const AuthContext = createContext({});

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const storage = localStorage.getItem("usuario-blog");

    if (storage) {
      const userData = JSON.parse(storage);

      // 🔴 TOKEN EXPIRADO → DESLOGA
      if (!userData.token || isTokenExpired(userData.token)) {
        localStorage.removeItem("usuario-blog");
        setUser(null);
        delete api.defaults.headers.common["Authorization"];
      } else {
        // ✅ token válido
        api.defaults.headers.common["Authorization"] =
          "Bearer " + userData.token;
        setUser(userData);
      }
    }

    setLoadingAuth(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loadingAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };